
import { Reducer, Effect } from 'umi';
import { getResourceList } from '@/services/resource';


export interface ResourceStateType {
    resourceList?: [];
    menuList?:[];
}

export interface ResourceModelType {
  namespace: string;
  state: ResourceStateType;
  effects: {
    getList: Effect;
  };
  reducers: {
    changeList: Reducer<ResourceStateType>;
    changeMenu: Reducer<ResourceStateType>;
  };
}

const resourceModel: ResourceModelType = {
  namespace: 'resource',
  state: {
    resourceList: [],
    menuList:[]
  },
  effects: {
    *getList(_, { call,put }) {
      const response = yield call(getResourceList);
      if(response.code === 0) { 
        yield put({type:"changeList",payload:response.data})
        yield put({type:"changeMenu",payload:JSON.parse(JSON.stringify(response.data))})
      }
    }
  },

  reducers: {
    changeList(state, { payload }) {

      return {
        ...state,
        resourceList:payload
      };
    },
    changeMenu(state, { payload }) {
      const menu = payload.filter((el:any)=>el.type === 1);
      const menuObj = {};
      menu.forEach((el:any) => {
        menuObj[el.id] = el;
      });
      // console.log(menu)
      menu.forEach((item:any) => {
        item.title = item.name;
        item.value = item.id;
        item.key = item.id;
        if(menuObj[item.pid]) {
          if(!menuObj[item.pid].children) {
            menuObj[item.pid].children = [];
          }
          menuObj[item.pid].children.push(item);
        }
      });
      return {
        ...state,
        menuList:menuObj['1'].children
      };
    },
  },
};

export default resourceModel;
